import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ProblemService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            const body = response;
            return {
                success: true,
                data: body.data || [],
                pagination: body.pagination || {},
                uniqueValues: body.uniqueValues || {},
                message: body.message || 'Liste getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch item');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message || 'Kayıt oluşturuldu' };
        } catch (error) {
            throw this._handleError(error, 'Failed to create');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message || 'Kayıt güncellendi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to update');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Kayıt silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete');
        }
    }

    async listCandidates(params = {}) {
        try {
            const response = await this.api.listCandidates(params);
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch candidates');
        }
    }

    async getCandidatesSummary() {
        try {
            const response = await this.api.getCandidatesSummary();
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch candidate summary');
        }
    }

    async acceptCandidate(id, data = {}) {
        try {
            const response = await this.api.acceptCandidate(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to accept candidate');
        }
    }

    async dismissCandidate(id) {
        try {
            const response = await this.api.dismissCandidate(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to dismiss candidate');
        }
    }

    async listSuggestionsForTicket(ticketId) {
        try {
            const response = await this.api.listSuggestionsForTicket(ticketId);
            return { success: true, data: response.data || [] };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch ticket suggestions');
        }
    }

    async listLinkedTickets(id) {
        try {
            const response = await this.api.listLinkedTickets(id);
            return { success: true, data: response.data || [] };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch linked tickets');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
